export const CHALLAN_LOADER_SCREEN_TEXTS = [
  "Checking with city's RTO...",
  'Fetching your challan details...',
  'Saving this vehicle to your ACKO App',
  'Almost ready! Just a second...',
]

export const LOADING_ALT = 'Loading'
export const DOWNLOAD_APP = 'Download the ACKO App'
export const CHALLAN_DETAIL_HEADING = 'To view all the details'
export const CHALLAN_ICON_ALT = 'Challan Icon'
export const CHALLAN_TEXT_DEFAULT = 'You may have a challan!'
export const CHALLAN_TEXT = (challanLength, challanAmount) =>
  `You have a ${challanLength} pending challans amounting to ₹${challanAmount}.00`
export const CHALLAN_DETAIL_TEXT =
  'We’ve saved the RTO-verified challan details like captured images, location, and more on the ACKO app.'
export const CHALLAN_MOBILE_INFO_ALT = 'Mobile Challan Info'
export const REG_CONTAINER_ALT = 'reg Container'
export const SCANNER_ALT = 'scanner image'
export const ERROR_FETCHING = 'Error fetching data:'
export const ENTITY_SERVICE = phoneNumber => `/api/user/?phone=${phoneNumber}`
export const AUTO_ASSET_ENDPOINT = '/asset_service/api/assets/create/vehicle?validate=false'
export const AUTO_ASSET_ENDPOINT_VEHICLE = '/asset_service/api/assets/vehicle'
export const CHALLAN_ENDPOINT = regNo =>
  `/vas/api/v1/challans/?registration-number=${regNo}&use-case=default&source=central-vas`
export const CHALLAN_SERVICE_TIMEOUT = 7000
export const CHALLAN_PATH_VARAIABLE_SOURCE_USECASE = '&source=acko-seo&use-case=cached-if-exist'
export const ASSET_ADDITION_SERVICE = (regNo, phoneNumber) =>
  `assetAdditionService?regNo=${regNo}&phoneNumber=${phoneNumber}`

export const TIME_OUT = 1000

export const VEHICLE_CHALLAN_ALT = 'Vehicle challan image'
export const NO_CHALLAN = 'No challans found'
export const PENDING_CHALLAN = 'There are pending challans against your vehicle'
export const UNPAID = 'UNPAID'
export const CHALLAN_FETCH_TIMEOUT = 5000
